import { z } from 'zod';
import { currencySchema, moneySchema, linkedDocumentSchema, UuidSchema, preLimitIdSchema, limitIdSchema, loanIdSchema, loanLimitSchema, loanSchema, loanProviderRequest, loanResponseStatus, loanStage, providerType, } from '@repo/shared/types';
import { loanResponseBaseSchema } from './loan-shared.schema';
var _loanSearchParams = z.object({
    provider: providerType,
    requestId: UuidSchema,
});
export var loanSuccessResponseBodyStage1 = loanResponseBaseSchema.extend({
    data: z.object({
        loanId: limitIdSchema,
        status: loanResponseStatus.refine(function (status) { return status === 'NEW'; }),
        providerRequest: loanProviderRequest,
        stage: loanStage.refine(function (value) { return value === 1; }),
    }),
});
export var loanSuccessResponseBodyStage7 = loanResponseBaseSchema.extend({
    data: z.object({
        loanId: loanIdSchema,
        status: loanResponseStatus.refine(function (status) { return status === 'REJECTED'; }),
        providerRequest: loanProviderRequest,
        preLimitId: preLimitIdSchema,
        limitId: limitIdSchema,
        rejectionReason: z.string().nullable(),
        rejectionDescription: z.array(z.string()).nullable(),
    }),
});
var otherStatus = loanResponseStatus.refine(function (status) { return status !== 'REJECTED' && status !== 'NEW'; });
export var loanSuccessResponseBodyStageOther = loanResponseBaseSchema.extend({
    data: z.object({
        preLimitId: preLimitIdSchema,
        loan: loanSchema.extend({
            limitId: limitIdSchema.optional(),
        }),
        status: otherStatus,
        stage: loanStage.refine(function (stage) { return stage !== 1 && stage !== 7; }),
        value: z.object({
            amount: moneySchema,
            currency: currencySchema,
        }),
        documents: z.array(linkedDocumentSchema).optional(),
        limit: loanLimitSchema,
    }),
});
export var loanSuccessResponseBody = z.union([
    loanSuccessResponseBodyStage1,
    loanSuccessResponseBodyStage7,
    loanSuccessResponseBodyStageOther,
]);
